import { createStyles, Stack } from '@mantine/core';
import type { SecodaAIReferencedObjectOut } from '@repo/api-codegen';
import { observer } from 'mobx-react-lite';
import type { AiChatStore } from '../store';
import type { PrefilledAgentData } from '../types';
import { AgentMessage } from './AgentMessage';
import { AiViewportWrapper } from './AiViewportWrapper';
import { UserMessage } from './UserMessage';

const useStyles = createStyles(
	(
		theme,
		{
			scrollContainerHeight,
			totalItems,
		}: {
			scrollContainerHeight?: number;
			totalItems: number;
		}
	) => ({
		container: {
			[`.ai-chat-wrapper[data-has-submitted-prompt] div[data-index="${totalItems - 1}"] &`]:
				{
					minHeight: `calc(${scrollContainerHeight ? `${scrollContainerHeight}px` : `-160px + 100dvh`})`,
				},
			paddingBottom: theme.spacing['5xl'],
		},
	})
);

export const MessageGroup = observer(
	({
		id,
		store,
		onReferencedObjectClick,
		shouldShowInlineReferencedObject,
		onCreateAgent,
	}: {
		id: string;
		store: AiChatStore;
		onReferencedObjectClick?: (
			referencedObject: SecodaAIReferencedObjectOut
		) => void;
		shouldShowInlineReferencedObject?: (
			referencedObject: SecodaAIReferencedObjectOut
		) => boolean;
		onCreateAgent: (data: PrefilledAgentData) => void;
	}) => {
		const scrollContainerHeight = document.querySelector(
			'.ai-chat-scroll-container'
		)?.clientHeight;

		const { classes } = useStyles({
			scrollContainerHeight,
			totalItems: store.messages.size,
		});

		return (
			<AiViewportWrapper>
				<Stack spacing={0} className={classes.container}>
					<UserMessage id={id} store={store} onCreateAgent={onCreateAgent} />
					<AgentMessage
						id={id}
						store={store}
						onReferencedObjectClick={onReferencedObjectClick}
						shouldShowInlineReferencedObject={shouldShowInlineReferencedObject}
						onCreateAgent={onCreateAgent}
					/>
				</Stack>
			</AiViewportWrapper>
		);
	}
);
